import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { AddSkills, Skills } from '../models/skills/skills';


@Injectable({
  providedIn: 'root'
})
export class SkillsService {

  constructor(
    private _http: HttpClient
  ) { }

    public getSkills(SkillsId?: number): Observable<Skills[]>{
        return this._http.get<Skills[]>(`${environment.api.url}/Skills?SkillsId=${SkillsId??''}`);
    }
  
    public deleteSkills(SkillsId: number): Observable<boolean> {
        return this._http.delete<any>(`${environment.api.url}/Skills/${SkillsId}`);
    }
  
    public addSkills(model: AddSkills): Observable<boolean> {
        return this._http.post<any>(`${environment.api.url}/Skills`, model);
    }
}
